import { render, staticRenderFns } from "./Template-Plain.vue?vue&type=template&id=2ca8bcac&"
import script from "./Template-Plain.vue?vue&type=script&lang=js&"
export * from "./Template-Plain.vue?vue&type=script&lang=js&"
import style0 from "./Template-Plain.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports